import React, { useEffect, useState, useRef } from "react";
// Custom shipping modal implemented inline below (removed CommonModal import)
import axios from "../../utils/axiosInstance";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import { toastSuccess, toastError } from "../../utils/alertHelper";
import { validateForm } from '../../utils/formUtils';
import { FaCloudUploadAlt, FaEye } from "react-icons/fa";
import CommonModal from '../../components/commonComponent/CommonModal';

const emptyShipping = {
  houseNo: "",
  society: "",
  landmark: "",
  area: "",
  city: "",
  state: "",
  country: "",
  pinCode: "",
};

const IMAGE_BASE_URL = process.env.REACT_APP_Image_URL || "https://api.solarestimate.in/image/";

const initialValues = {
  firstName: "",
  lastName: "",
  mobile: "",
  alternateMobile: "",
  email: "",
  dob: "",
  profilePhoto: null,

  companyName: "",
  companyType: "",
  gstNumber: "",
  gstFile: null,

  aadhaarNumber: "",
  aadhaarFront: null,
  aadhaarBack: null,

  panNumber: "",
  panFile: null,

  bankName: "",
  accountNumber: "",
  ifsc_Code: "",
  branchName: "",
  chequeFile: null,

  userStatus: "",
  userCategory: "",
  accountStatus: "",
  userType: "Client",
  
  billTo: {
    houseNo: "",
    society: "",
    landmark: "",
    area: "",
    city: "",
    state: "",
    country: "",
    pinCode: "",
  },

  shipTo: [],
};

const ClientCreate = () => {
  const [values, setValues] = useState(initialValues);
  const [currentShip, setCurrentShip] = useState(emptyShipping);
  const [editingShipIndex, setEditingShipIndex] = useState(null);
  const [showShipModal, setShowShipModal] = useState(false);
  const [preview, setPreview] = useState("");
  const [dropdowns, setDropdowns] = useState({
    companyType: [],
    status: [
      { _id: "Active", name: "Active" },
      { _id: "Inactive", name: "Inactive" },
    ],
    category: [],
    countries: [],
    states: [],
    cities: [],
    accountStatus: [],
  });

  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const basePath = location.pathname.startsWith('/user') ? '/user' : '/admin';
  const fileRef = useRef(null);

  /* ================= MODAL PREVIEW ================= */
  const openInNewTab = (file) => {
    if (!file) return;
    try {
      let url = "";
      if (typeof file === "string") {
        url = file.startsWith("http") ? file : `${IMAGE_BASE_URL}${file}`;
        window.open(url, "_blank");
        return;
      }

      if (file instanceof File) {
        const objectUrl = URL.createObjectURL(file);
        const newWin = window.open(objectUrl, "_blank");
        setTimeout(() => { try { URL.revokeObjectURL(objectUrl); } catch (e) {} }, 5000);
        return;
      }

      if (file && file.url) {
        window.open(file.url, "_blank");
        return;
      }
    } catch (err) {
    }
  };

  const openPreview = (file) => {
    if (!file) return;
    // file may be a File object or a url/filename string
    let previewUrl = '';
    try {
      if (typeof file === 'string') {
        // if already an absolute URL, use it; otherwise prepend IMAGE_BASE_URL
        previewUrl = file.startsWith('http') ? file : `${IMAGE_BASE_URL}${file}`;
      } else if (file instanceof File) {
        previewUrl = URL.createObjectURL(file);
      } else if (file && file.url) {
        previewUrl = file.url;
      } else {
        return;
      }
    } catch (err) {
      console.error('openPreview error', err);
      return;
    }
    setPreview(previewUrl);
    const modalEl = document.getElementById("imagePreviewModal");
    if (!modalEl) return;

    try {
      if (window.bootstrap && window.bootstrap.Modal) {
        const ModalClass = window.bootstrap.Modal;
        const instance =
          typeof ModalClass.getOrCreateInstance === "function"
            ? ModalClass.getOrCreateInstance(modalEl)
            : new ModalClass(modalEl);
        instance.show();
        return;
      }

      if (window.jQuery && typeof window.jQuery(modalEl).modal === "function") {
        window.jQuery(modalEl).modal("show");
        return;
      }
    } catch (err) {
    }

    // Fallback: toggle classes/styles to show modal and add backdrop
    modalEl.classList.add("show");
    modalEl.style.display = "block";
    modalEl.setAttribute("aria-modal", "true");
    modalEl.removeAttribute("aria-hidden");
    const backdrop = document.createElement("div");
    backdrop.className = "modal-backdrop fade show";
    document.body.appendChild(backdrop);
  };

  /* ================= FILE CHANGE ================= */
  const handleFile = (e) => {
    setValues({ ...values, [e.target.name]: e.target.files[0] });
  };

  /* ================= FETCH DROPDOWNS ================= */
  useEffect(() => {
    (async () => {
      try {
        const [ct, uc, countriesRes, statesRes, citiesRes] = await Promise.all([
          axios.get("/admin/api/businessType"),
          axios.get("/admin/api/userCategory"),
          axios.get("/admin/api/country"),
          axios.get("/admin/api/state"),
          axios.get("/admin/api/city"),
        ]);

        const companyTypeList = (ct && (ct.data && (ct.data.businessTypes || ct.data.businessType || ct.data.companyTypes)) ) || (Array.isArray(ct && ct.data) ? ct.data : []) || [];
        const categoryList = (uc && (uc.data && (uc.data.userCategories || uc.data.categories || uc.data.data)) ) || (Array.isArray(uc && uc.data) ? uc.data : []) || [];

        const countryList = (countriesRes && (countriesRes.data && (countriesRes.data.countries || countriesRes.data.country || countriesRes.data.data))) || (Array.isArray(countriesRes && countriesRes.data) ? countriesRes.data : []) || [];
        const stateList = (statesRes && (statesRes.data && (statesRes.data.states || statesRes.data.state || statesRes.data.data))) || (Array.isArray(statesRes && statesRes.data) ? statesRes.data : []) || [];
        const cityList = (citiesRes && (citiesRes.data && (citiesRes.data.cities || citiesRes.data.city || citiesRes.data.data))) || (Array.isArray(citiesRes && citiesRes.data) ? citiesRes.data : []) || [];

        setDropdowns((prev) => ({
          companyType: companyTypeList,
          status: prev.status,
          category: Array.isArray(categoryList) ? categoryList : prev.category || [],
          countries: Array.isArray(countryList) ? countryList : [],
          states: Array.isArray(stateList) ? stateList : [],
          cities: Array.isArray(cityList) ? cityList : [],
        }));
      } catch (err) {
        console.error("Failed to load dropdowns:", err);
        toastError("Failed to load dropdown data. Check API URL and server.");
      }
    })();
  }, []);

  /* ================= EDIT ================= */
  useEffect(() => {
    if (!id) return;
    axios.get(`/api/user/${id}`).then(res => {
      const payload = res && res.data ? res.data : {};
      // Many APIs return the actual object under `data` (Status/Message wrapper)
      const userData = payload.data || payload.user || payload.client || payload || {};

      // Normalize billing object: backend may return `bill` or `billTo`
      const bill = userData.bill || userData.billTo || {};
      const billTo = {
        houseNo: bill.houseNo || bill.houseNo || '',
        society: bill.society || bill.societyName || bill.societyName || '',
        landmark: bill.landmark || '',
        area: bill.area || '',
        city: bill.city || '',
        state: bill.state || '',
        country: bill.country || '',
        pinCode: bill.pinCode || bill.pin || ''
      };

      // Map server fields to form fields
      const mapped = {
        firstName: userData.firstName || userData.fname || '' ,
        lastName: userData.lastName || userData.lname || '' ,
        mobile: userData.mobileNumber || userData.mobile || userData.phone || '',
        alternateMobile: userData.alternateMobile || userData.altMobile || '',
        email: userData.email || '',
        dob: userData.birthDate || userData.dob || '',
        profilePhoto: userData.profilepic || userData.profilepicUrl || userData.profileImage || null,

        companyName: userData.business || userData.companyName || '',
        // backend may return businessType as object or id string
        companyType: (userData.businessType && (userData.businessType._id || userData.businessType)) || userData.companyType || '',
        gstNumber: userData.gstNumber || userData.gst_number || '',

        aadhaarNumber: userData.aadharNumber || userData.aadharNumber || '',
        aadhaarFront: userData.aadhaarFront || null,
        aadhaarBack: userData.aadhaarBack || null,

        panNumber: userData.pan_number || userData.panNumber || '',
        panFile: userData.panFile || null,

        bankName: userData.bankName || '',
        accountNumber: userData.accountNumber || userData.accountNo || '',
        ifsc_Code: userData.ifsc_Code || userData.ifsc || '',
        branchName: userData.branchName || '',
        chequeFile: userData.chequeFile || userData.cancelledCheque || null,

        userStatus: userData.userStatus || userData.status || '',
        userCategory: (userData.userCategory && (userData.userCategory._id || userData.userCategory)) || userData.userCategory || '',
        accountStatus: userData.accountStatus || userData.account_state || userData.account || '',
      };

      // Merge into form values ensuring nested objects exist
      setValues(prev => ({
        ...initialValues,
        ...prev,
        ...mapped,
        billTo,
        shipTo: Array.isArray(userData.shipTo) ? userData.shipTo.map(s => ({
          _id: s._id,
          houseNo: s.houseNo || '',
          society: s.society || s.societyName || s.societyName || '',
          landmark: s.landmark || '',
          area: s.area || '',
          city: s.city || s.cityId || '',
          state: s.state || s.stateId || '',
          country: s.country || s.countryId || '',
          pinCode: s.pinCode || s.pin || ''
        })) : (Array.isArray(prev.shipTo) ? prev.shipTo : []),
      }));

      // If backend provides seeded lists along with user data, use them
      const statusList = payload.statuses || payload.statusList || payload.userStatusList || res.data.statuses || res.data.statusList;
      const categoryList = payload.categories || payload.categoryList || payload.userCategoryList || res.data.categories || res.data.categoryList;
      const companyTypeList = payload.businessTypes || payload.companyTypes || payload.businessTypeList || res.data.businessTypes || res.data.companyTypes;
      setDropdowns((prev) => ({
        ...prev,
        status: Array.isArray(statusList) ? statusList : prev.status,
        category: Array.isArray(categoryList) ? categoryList : prev.category,
        companyType: Array.isArray(companyTypeList) ? companyTypeList : prev.companyType,
      }));
    }).catch(err => {
      toastError('Failed to load user data for edit');
    });
  }, [id]);

  const addShipping = () => {
    openShippingModal();
  };
  const openShippingModal = (index = null) => {
    if (index !== null && values.shipTo && values.shipTo[index]) {
      setCurrentShip({ ...values.shipTo[index] });
      setEditingShipIndex(index);
    } else {
      setCurrentShip({ ...emptyShipping });
      setEditingShipIndex(null);
    }
    setShowShipModal(true);
    console.log('openShippingModal', index);
  };

  const closeShippingModal = () => {
    setShowShipModal(false);
    console.log('closeShippingModal');
  };

  const saveShipping = () => {
    const newShip = { ...currentShip };
    const list = Array.isArray(values.shipTo) ? [...values.shipTo] : [];
    if (editingShipIndex !== null && editingShipIndex >= 0) {
      list[editingShipIndex] = newShip;
    } else {
      list.push(newShip);
    }
    setValues({ ...values, shipTo: list });
    setShowShipModal(false);
  };

  const shippingFields = [
    { name: "houseNo", label: "House / Flat No" },
    { name: "society", label: "Society" },
    { name: "landmark", label: "Landmark" },
    { name: "area", label: "Area" },
    { name: "city", label: "City" },
    { name: "state", label: "State" },
    { name: "country", label: "Country" },
    { name: "pinCode", label: "Pin Code" },
  ];

  const deleteShipping = (index) => {
    const list = Array.isArray(values.shipTo) ? [...values.shipTo] : [];
    list.splice(index, 1);
    setValues({ ...values, shipTo: list });
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const rules = {
      firstName: { required: true },
      email: { required: true, email: true },
      mobile: { required: true, mobile: true },
      companyName: { required: true },
      companyType: { required: true },
      userStatus: { required: true },
      userCategory: { required: true },
    };
    // if (values.gstNumber) rules.gstNumber = { gst: true };
    if (values.panNumber) rules.panNumber = { uppercase: true };

    const errors = validateForm(values, rules);
    if (errors && Object.keys(errors).length > 0) {
      const first = Object.values(errors)[0];
      toastError(first);
      return;
    }

    try {
      const fd = new FormData();

      fd.append("firstName", values.firstName || "");
      fd.append("lastName", values.lastName || "");
      fd.append("email", values.email || "");
      fd.append("phone_code", values.phone_code || "");
      fd.append("iso_code", values.iso_code || "");
      fd.append("mobileNumber", values.mobile || values.mobileNumber || "");
      fd.append("birthDate", values.dob || values.birthDate || "");
      if (values.profilePhoto) fd.append("profilepic", values.profilePhoto);
      fd.append("business", values.companyName || "");
      fd.append("businessType", values.companyType || "");
      fd.append("gstNumber", values.gstNumber || "");
      fd.append("aadharNumber", values.aadhaarNumber || "");
      fd.append("pan_number", values.panNumber || "");
      const userCategoryVal = values.userCategory && (values.userCategory._id || values.userCategory);
      if (userCategoryVal) fd.append("userCategory", userCategoryVal);
      if (values.userStatus) fd.append("userStatus", values.userStatus);
      // accountStatus is editable only during edit (id present)
      if (id && values.accountStatus) fd.append("accountStatus", values.accountStatus);
      fd.append("bankName", values.bankName || "");
      if (values.accountNumber) fd.append("accountNumber", values.accountNumber);
      if (values.ifsc_Code) fd.append("ifsc_Code", values.ifsc_Code);
      if (values.branchName) fd.append("branchName", values.branchName);
      if (values.billTo) {
        const b = { ...values.billTo };
        const cityVal = b.city && typeof b.city === 'object' ? (b.city._id || b.city) : b.city || '';
        const stateVal = b.state && typeof b.state === 'object' ? (b.state._id || b.state) : b.state || '';
        const countryVal = b.country && typeof b.country === 'object' ? (b.country._id || b.country) : b.country || '';

        // flat keys expected by some APIs
        fd.append('bill_houseNo', b.houseNo || '');
        fd.append('bill_societyName', b.societyName || b.society || '');
        fd.append('bill_landmark', b.landmark || '');
        fd.append('bill_area', b.area || '');
        fd.append('bill_city', cityVal);
        fd.append('bill_state', stateVal);
        fd.append('bill_country', countryVal);
        fd.append('bill_pinCode', b.pinCode || '');

        const billPayload = { ...b, societyName: b.societyName || b.society };
        billPayload.city = cityVal;
        billPayload.state = stateVal;
        billPayload.country = countryVal;
        // do not append object forms; backend expects flat `bill_*` keys and/or `shipping_addresses`
      }

      if (Array.isArray(values.shipTo)) {
        const shipping = values.shipTo.map(s => {
          const cityVal = s.city && typeof s.city === 'object' ? (s.city._id || s.city) : s.city || '';
          const stateVal = s.state && typeof s.state === 'object' ? (s.state._id || s.state) : s.state || '';
          const countryVal = s.country && typeof s.country === 'object' ? (s.country._id || s.country) : s.country || '';
          return {
            houseNo: s.houseNo || '',
            societyName: s.societyName || s.society || '',
            landmark: s.landmark || '',
            area: s.area || '',
            city: cityVal,
            state: stateVal,
            country: countryVal,
            pinCode: s.pinCode || ''
          };
        });
        fd.append('shipTo', JSON.stringify(shipping));
      }

      if (values.gstFile) fd.append("gstFile", values.gstFile);
      if (values.aadhaarFront) fd.append("aadhaarFront", values.aadhaarFront);
      if (values.aadhaarBack) fd.append("aadhaarBack", values.aadhaarBack);
      if (values.panFile) fd.append("panFile", values.panFile);
      if (values.chequeFile) fd.append("chequeFile", values.chequeFile);

      // Ensure userType is sent (backend requires it)
      fd.append("userType", values.userType || "Client");

      try {
        const keys = [];
        for (const pair of fd.entries()) {
          keys.push({ key: pair[0], type: pair[1] && pair[1].name ? 'file' : typeof pair[1] });
        }
        
      } catch (e) {
       
      }

      const res = id
        ? await axios.put(`/api/user/${id}`, fd)
        : await axios.post("/api/user/create", fd);

      if (res && res.data && res.data.Status === 1) {
        toastSuccess(id ? "User Updated" : "User Created");
        if (location.pathname.startsWith('/user')) {
          const createdId = id || (res && res.data && (res.data.id || res.data._id || (res.data.data && (res.data.data._id || res.data.data.id))));
          navigate(`${basePath}/client/view/${createdId}`);
        } else {
          navigate("/admin/client");
        }
      } else {
        toastError((res && res.data && (res.data.Message || res.data.message)) || "Save failed");
      }
    } catch (err) {

      const serverMsg = err && err.response && (err.response.data && (err.response.data.Message || err.response.data.message)) || (err && err.message);
      toastError(serverMsg || "Something went wrong");
    }
  };

  return (
    <div className="container py-4" style={{ maxWidth: 1300 }}>
      <div className="d-flex justify-content-between mb-3">
        <h4 className="fw-bold">{id ? "Edit Client" : "Add Client Registration"}</h4>
        <Link to="/admin/client">&larr; Client</Link>
      </div>
      <form className="p-4 rounded-3 border" style={{ background: "#F6F7F8" }} onSubmit={handleSubmit} encType="multipart/form-data">
        <h5 className="fw-semibold border-bottom">Personal Information</h5>
        <div className="row">
          <div className="col-md-3 mb-3"><label>First Name <span className="text-danger">*</span></label><input className="form-control" value={values.firstName} onChange={e => setValues({ ...values, firstName: e.target.value })} /></div>
          <div className="col-md-3 mb-3"><label>Last Name <span className="text-danger">*</span></label><input className="form-control" value={values.lastName} onChange={e => setValues({ ...values, lastName: e.target.value })} /></div>
          <div className="col-md-3 mb-3"><label>Mobile <span className="text-danger">*</span></label><input className="form-control" value={values.mobile} onChange={e => setValues({ ...values, mobile: e.target.value })} /></div>
          <div className="col-md-3 mb-3">
            <label className="d-block">User Profile</label>
            <div className="d-flex gap-2">
                <div
                  className="border rounded d-flex align-items-center justify-content-center"
                  style={{ height: 140, width: '100%', cursor: "pointer", background: "#fff", overflow: 'hidden' }}
                  onClick={() => fileRef.current.click()}
                >
                  <input type="file" name="profilePhoto" ref={fileRef} hidden accept="image/*" onChange={handleFile} />
                  {values.profilePhoto ? (
                    typeof values.profilePhoto === 'string' ? (
                      <img
                        src={values.profilePhoto.startsWith('http') ? values.profilePhoto : `${IMAGE_BASE_URL}${values.profilePhoto}`}
                        alt="profile"
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                      />
                    ) : values.profilePhoto instanceof File ? (
                      <img
                        src={URL.createObjectURL(values.profilePhoto)}
                        alt="profile"
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                      />
                    ) : values.profilePhoto.url ? (
                      <img
                        src={values.profilePhoto.url}
                        alt="profile"
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                      />
                    ) : (
                      <div className="text-muted">No image selected</div>
                    )
                  ) : (
                    <div className="text-center">
                      <FaCloudUploadAlt size={30} className="text-muted mb-2" />
                      <div className="text-muted">Upload Photo</div>
                    </div>
                  )}
                </div>
              </div>
          </div>
          <div className="col-md-3 mb-3"><label>Alternate Mobile</label><input className="form-control" value={values.alternateMobile} onChange={e => setValues({ ...values, alternateMobile: e.target.value })} /></div>
          <div className="col-md-3 mb-3"><label>Email <span className="text-danger">*</span></label><input className="form-control" value={values.email} onChange={e => setValues({ ...values, email: e.target.value })} /></div>
          <div className="col-md-3 mb-3"><label>Date of Birth</label><input type="date" className="form-control" value={values.dob} onChange={e => setValues({ ...values, dob: e.target.value })} /></div>
        </div>
        <h5 className="fw-semibold mt-4 border-bottom">Business Details</h5>
        <div className="row">
          <div className="col-md-3 mb-3"><label>Company Name <span className="text-danger">*</span></label><input className="form-control" value={values.companyName} onChange={e => setValues({ ...values, companyName: e.target.value })} /></div>
          <div className="col-md-3 mb-3">
            <label>Company Type <span className="text-danger">*</span></label>
            <select className="form-select" value={values.companyType} onChange={e => setValues({ ...values, companyType: e.target.value })}>
              <option value="">Select</option>
              {dropdowns.companyType.map(i => <option key={i._id} value={i._id}>{i.name}</option>)}
            </select>
          </div>
        </div>
          <div className="row">
          <div className="col-md-3 mb-3"><label>GST Number</label><input className="form-control" value={values.gstNumber} onChange={e => setValues({ ...values, gstNumber: e.target.value })} /></div>
          <div className="col-md-3 mb-3"><label>AADHAAR Number</label><input className="form-control" value={values.aadhaarNumber} onChange={e => setValues({ ...values, aadhaarNumber: e.target.value })} /></div>
          <div className="col-md-3 mb-3"><label>PAN Number</label><input className="form-control" value={values.panNumber} onChange={e => setValues({ ...values, panNumber: e.target.value })} /></div>
        </div>
        <div className="row">
          <div className="col-md-3 mb-3">
            <label>GST Certificate</label>
            <div className="d-flex gap-2">
              <input type="file" name="gstFile" className="form-control" onChange={handleFile} />
              <button type="button" className="btn btn-sm btn-outline-secondary" title="View GST certificate" onClick={() => openPreview(values.gstFile)}>
                <FaEye />
              </button>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <label>AADHAAR CARD Front</label>
            <div className="d-flex gap-2">
              <input type="file" name="aadhaarFront" className="form-control" onChange={handleFile} />
              <button type="button" className="btn btn-sm btn-outline-secondary" title="View AADHAAR CARD Front" onClick={() => openPreview(values.aadhaarFront)}>
                <FaEye />
              </button>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <label>AADHAAR CARD Back</label>
            <div className="d-flex gap-2">
              <input type="file" name="aadhaarBack" className="form-control" onChange={handleFile} />
              <button type="button" className="btn btn-sm btn-outline-secondary" title="View AADHAAR CARD Back" onClick={() => openPreview(values.aadhaarBack)}>
                <FaEye />
              </button>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <label>PAN Image</label>
            <div className="d-flex gap-2">
              <input type="file" name="panFile" className="form-control" onChange={handleFile} />
              <button type="button" className="btn btn-sm btn-outline-secondary" title="View PAN Image" onClick={() => openPreview(values.panFile)}>
                <FaEye />
              </button>
            </div>
          </div>
        </div>
       <h5 className="fw-semibold mt-4 border-bottom">BANK Details</h5>
        <div className="row">
          <div className="col-md-3 mb-3"><label>Bank Name</label><input className="form-control" value={values.bankName} onChange={e => setValues({ ...values, bankName: e.target.value })} /></div>
          <div className="col-md-3 mb-3"><label>Account Number</label><input className="form-control" value={values.accountNumber} onChange={e => setValues({ ...values, accountNumber: e.target.value })} /></div>
          <div className="col-md-3 mb-3"><label>IFSC Code</label><input className="form-control" value={values.ifsc_Code} onChange={e => setValues({ ...values, ifsc_Code: e.target.value })} /></div>
          <div className="col-md-3 mb-3"><label>Branch Name</label><input className="form-control" value={values.branchName} onChange={e => setValues({ ...values, branchName: e.target.value })} /></div>
        </div>
        <div className="row">
          <div className="col-md-3 mb-3">
            <label>Cancelled Cheque</label> 
            <div className="d-flex gap-2">
              <input type="file" name="chequeFile" className="form-control" onChange={handleFile} />
              <button type="button" className="btn btn-sm btn-outline-secondary" title="View Cancelled Cheque" onClick={() => openPreview(values.chequeFile)}>
                <FaEye />
              </button>
            </div>
          </div>
        </div>
         <h5 className="fw-semibold mt-4 border-bottom">Account Details</h5>
        <div className="row">
          <div className="col-md-3 mb-3">
            <label>User Status <span className="text-danger">*</span></label>
            <select className="form-select" value={values.userStatus} onChange={e => setValues({ ...values, userStatus: e.target.value })}>
              <option value="">Select</option>
              {dropdowns.status.map(i => <option key={i._id} value={i._id}>{i.name}</option>)}
            </select>
          </div>
          <div className="col-md-3 mb-3">
            <label>User Category <span className="text-danger">*</span></label>
            <select className="form-select" value={values.userCategory} onChange={e => setValues({ ...values, userCategory: e.target.value })}>
              <option value="">Select</option>
              {dropdowns.category.map(i => <option key={i._id} value={i._id}>{i.name}</option>)}
            </select>
          </div>
          {id && (
            <div className="col-md-3 mb-3">
              <label>Account Status</label>
              <select className="form-select" value={values.accountStatus} onChange={e => setValues({ ...values, accountStatus: e.target.value })}>
                <option value="">Select</option>
                <option value="Verified">Verified</option>
                <option value="Pending">Pending</option>
                <option value="Rejected">Rejected</option>
              </select>
            </div>
          )}
        </div>
        <h5 className="fw-semibold mt-4 border-bottom">Address Details</h5>
        {/* Bill To fields */}
        <div className="row mb-3">
          <div className="col-md-3 mb-3"><label>House/Flat Number</label><input className="form-control" value={values.billTo.houseNo} onChange={e => setValues({ ...values, billTo: { ...values.billTo, houseNo: e.target.value } })} /></div>
          <div className="col-md-3 mb-3"><label>Society/Apartment Name</label><input className="form-control" value={values.billTo.society} onChange={e => setValues({ ...values, billTo: { ...values.billTo, society: e.target.value } })} /></div>
          <div className="col-md-3 mb-3"><label>Landmark/Nearby</label><input className="form-control" value={values.billTo.landmark} onChange={e => setValues({ ...values, billTo: { ...values.billTo, landmark: e.target.value } })} /></div>
          <div className="col-md-3 mb-3"><label>Area</label><input className="form-control" value={values.billTo.area} onChange={e => setValues({ ...values, billTo: { ...values.billTo, area: e.target.value } })} /></div>
        </div>
        <div className="row mb-3">
          <div className="col-md-3 mb-3">
            <label>City</label>
            <select className="form-select" value={(values.billTo.city && (values.billTo.city._id || values.billTo.city)) || ''} onChange={e => setValues({ ...values, billTo: { ...values.billTo, city: e.target.value } })}>
              <option value="">Select</option>
              {dropdowns.cities.filter(ci => !values.billTo.state || (ci.state && (ci.state._id === (values.billTo.state._id || values.billTo.state) || ci.state === (values.billTo.state._id || values.billTo.state)))).map(ci => <option key={ci._id} value={ci._id}>{ci.name}</option>)}
            </select>
          </div>
          <div className="col-md-3 mb-3">
            <label>State</label>
            <select className="form-select" value={(values.billTo.state && (values.billTo.state._id || values.billTo.state)) || ''} onChange={e => setValues({ ...values, billTo: { ...values.billTo, state: e.target.value, city: '' } })}>
              <option value="">Select</option>
              {dropdowns.states.filter(s => !values.billTo.country || (s.country && (s.country._id === (values.billTo.country._id || values.billTo.country) || s.country === (values.billTo.country._id || values.billTo.country)) ) ).map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
            </select>
          </div>
          <div className="col-md-3 mb-3">
            <label>Country</label>
            <select className="form-select" value={(values.billTo.country && (values.billTo.country._id || values.billTo.country)) || ''} onChange={e => setValues({ ...values, billTo: { ...values.billTo, country: e.target.value, state: '', city: '' } })}>
              <option value="">Select</option>
              {dropdowns.countries.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
            </select>
          </div>
          <div className="col-md-3 mb-3"><label>Pin Code</label><input className="form-control" value={values.billTo.pinCode} onChange={e => setValues({ ...values, billTo: { ...values.billTo, pinCode: e.target.value } })} /></div>
        </div>

        {/* Ship To list */}
        {Array.isArray(values.shipTo) && values.shipTo.length > 0 ? (
          values.shipTo.map((s, i) => (
            <div className="d-flex align-items-start justify-content-between border rounded p-3 mb-2" key={i}>
              <div>
                <strong>Ship To {i + 1}</strong>
                <div className="text-muted">{s.houseNo || ''} {s.society || ''} {s.area || ''} {
                  (() => {
                    const cityVal = s.city;
                    if (!cityVal) return "";
                    if (typeof cityVal === "object") return cityVal.name || cityVal.label || "";
                    const found = (dropdowns.cities || []).find(ci => String(ci._id) === String(cityVal));
                    return found ? found.name : cityVal;
                  })()
                } {s.pinCode || ''}</div>
              </div>
              <div>
                <button type="button" className="btn btn-sm btn-primary me-2" onClick={() => openShippingModal(i)}>Edit</button>
                <button type="button" className="btn btn-sm btn-danger" onClick={() => deleteShipping(i)}>Delete</button>
              </div>
            </div>
          ))
        ) : (
          <div className="fw-semibold mt-4 border-bottom h5" style={{ marginBottom: "18px" }}>Shipping Addresses</div>
        )}

        <button type="button" className="btn btn-primary btn-sm" style={{ fontSize: "14px" }} onClick={() => openShippingModal()}>
          <i className="fas fa-plus me-1"> </i> Add New Shipping Address
        </button>

        <div className="text-end mt-4">
          <button type="button" className="btn btn-secondary me-2" onClick={() => navigate("/admin/client")}>Cancel</button>
          <button className="btn btn-primary">Save Client</button>
        </div>
      </form>
      <CommonModal
        visible={showShipModal}
        title="Shipping Address"
        values={currentShip}
        onChange={(vals) => {
          if (vals.country !== currentShip.country) {
            setCurrentShip({ ...vals, state: '', city: '' });
            return;
          }
          if (vals.state !== currentShip.state) {
            setCurrentShip({ ...vals, city: '' });
            return;
          }
          setCurrentShip(vals);
        }}
        onCancel={closeShippingModal}
        onSubmit={saveShipping}
        submitLabel="Save Address"
        cancelLabel="Close"
        fields={[
          { name: 'houseNo', label: 'House / Flat No', type: 'text' },
          { name: 'society', label: 'Society', type: 'text' },
          { name: 'landmark', label: 'Landmark', type: 'text' },
          { name: 'area', label: 'Area', type: 'text' },
          { name: 'country', label: 'Country', type: 'select', options: dropdowns.countries.map(c => ({ value: c._id, label: c.name })) },
          { name: 'state', label: 'State', type: 'select', options: dropdowns.states.filter(s => !currentShip.country || (s.country && (s.country._id === (currentShip.country._id || currentShip.country) || s.country === (currentShip.country._id || currentShip.country)))).map(s => ({ value: s._id, label: s.name })) },
          { name: 'city', label: 'City', type: 'select', options: dropdowns.cities.filter(ci => !currentShip.state || (ci.state && (ci.state._id === (currentShip.state._id || currentShip.state) || ci.state === (currentShip.state._id || currentShip.state)))).map(ci => ({ value: ci._id, label: ci.name })) },
          { name: 'pinCode', label: 'Pin Code', type: 'text' },
        ]}
      />
      <div className="modal fade" id="imagePreviewModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header"></div>
            <div className="modal-body text-center">
              <img src={preview} className="img-fluid rounded-3" alt="preview" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientCreate;
